// src/services/feedbackApi.js

/**
 * Submit user feedback to the backend API
 * @param {string} token - Auth token
 * @param {object} feedbackData - The feedback data to submit
 * @returns {Promise} - API response
 */
export const submitFeedback = async (token, feedbackData) => {
    if (!token) {
      throw new Error('Authentication required');
    }
  
    try {
      // Use the environment variable for the API URL, just like in UserHistory.js
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      
      const response = await fetch(`${apiUrl}/auth/add_user_feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          feedback: feedbackData
        })
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit feedback');
      }
  
      return await response.json();
    } catch (error) {
      throw error;
    }
  };